/**
 * Read a Frosted Aura CSS custom property at runtime so charts (Recharts writes
 * colors as SVG presentation attributes, where `var(--x)` does not resolve) stay
 * token-driven instead of hard-coding hex. Falls back to the Aura accent.
 */
export function readToken(name: string, fallback = '#5C7E8F'): string {
  if (typeof window === 'undefined') return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}
